import { c as _c } from "react/compiler-runtime";
import { useSubscription } from "@/components/modules/subscription/hooks/useSubscription";
import { usePortfolios } from "../api/queries/usePortfolios";
export function usePropertiesLimit() {
  const $ = _c(9);
  const {
    maxNumberOfPropertiesAllowed
  } = useSubscription();
  const {
    data,
    isLoading
  } = usePortfolios();
  let t0;
  if ($[0] !== data?.data) {
    t0 = data?.data ?? [];
    $[0] = data?.data;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = t0.filter(_temp);
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const ownedCount = t1.length;
  const t2 = ownedCount >= maxNumberOfPropertiesAllowed;
  let t3;
  if ($[4] !== isLoading || $[5] !== maxNumberOfPropertiesAllowed || $[6] !== ownedCount || $[7] !== t2) {
    t3 = {
      ownedCount,
      maxNumberOfPropertiesAllowed,
      isPropertiesMaxed: t2,
      isLoading
    };
    $[4] = isLoading;
    $[5] = maxNumberOfPropertiesAllowed;
    $[6] = ownedCount;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
function _temp(portfolio) {
  return portfolio.collaborationDetails?.isOwner !== false;
}